import Action from "../interfaces/Action";
import ActionTypeEnum from "../enums/ActionTypeEnum";
import { CartUpsellConfig } from "../interfaces/cart/CartUpsell";

export default function upsellsReducer(
    state: CartUpsellConfig = { layout: null, upsells: [] },
    action: Action,
): CartUpsellConfig {
    switch (action.type) {
        case ActionTypeEnum.UPSELLS_SET:
            return action.upsells;
        default:
            return state;
    }
}
